import { useIntl } from "react-intl";

import { ButtonBase } from "@/components/ButtonBase/ButtonBase";
import { IconGreenPlus } from "@/components/Icons";

interface Props {
  servicesSelectedCount?: number;
  onClick: () => void;
}

export const SelectedAdditionalServicesCard = ({
  servicesSelectedCount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <ButtonBase
      className="flex w-full items-start gap-2 rounded-2xl border border-surface-neutral-medium bg-surface-neutral-soft p-3 text-start text-sm font-medium"
      onClick={onClick}
    >
      <IconGreenPlus />
      <div className="flex flex-col gap-0.5 text-sm">
        <div className="font-medium text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Additional services",
            description:
              "Section heading for optional add-ons (extra baggage, meal selection) per traveller",
          })}
        </div>
        {servicesSelectedCount ? (
          <div className="font-medium text-core-accent-600">
            {intl.formatMessage(
              {
                defaultMessage:
                  "{count, plural, one {# service} other {# services}} selected",
                description:
                  "Count of additional services selected for a traveller",
              },
              { count: servicesSelectedCount },
            )}
          </div>
        ) : (
          <div className="text-text-tertiary">
            {intl.formatMessage({
              defaultMessage: "No services selected",
              description:
                "Status label indicating no additional services are selected for a traveller",
            })}
          </div>
        )}
      </div>
      <div className="my-auto ms-auto leading-5 font-bold text-text-interactive">
        {servicesSelectedCount
          ? intl.formatMessage({
              defaultMessage: "Edit",
              description:
                "Generic 'Edit' button label to modify an existing item",
            })
          : intl.formatMessage({
              defaultMessage: "Add",
              description: "Generic 'Add' button label",
            })}
      </div>
    </ButtonBase>
  );
};
